/* global google:false */
import angular from 'angular';

module.exports = angular.module('market.directives.od-map', [])
.directive('odMap', function() {
  if (typeof(google) === 'undefined' || !google.maps) {
    console.warn('od-map requires Google Maps JavaScript API.');
    return {};
  }

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      scope.$watch(attrs.odMap, function(address) {
        if (!address) return;

        var center = new google.maps.LatLng(address.latitude, address.longitude)
          , map = new google.maps.Map(element[0], {
              center: center,
              disableDoubleClickZoom: true,
              draggable: false,
              scrollwheel: false,
              streetViewControl: false,
              mapTypeControl: false,
              zoomControl: false,
              zoom: 15
            });
        new google.maps.Marker({ position: center, map: map });
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/directives/od-map.js
 **/